import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-traveloptions',
  templateUrl: './traveloptions.component.html',
  styleUrls: ['./traveloptions.component.scss']
})
export class TravelOptionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    window.location.href = '//aplanbyvolvo.com/osd-travel-options';

  }

}
